import {ApiResponseDto, BasePopupProps} from "../../../../utils/Models";
import {useOrderPreviewContext} from "../OrderPreviewContext";
import {useState} from "react";
import {
    useFlintNotificationContext
} from "../../../../components/page_components/common/notifications/FlintNotificationContext";
import {OrderPreviewModelStateType, OrderPreviewVivoPanelModel, TimeReportingRequest} from "../../order.models";
import axios from "axios";
import {ApiUrl_Orders_ReportOrderActivities} from "../../../../utils/Endpoints";
import {useTranslation} from "react-i18next";
import FlintLoadingWrapper from "../../../../components/page_components/common/loading/FlintLoadingWrapper";
import FlintNumericTextBox from "../../../../components/controls/FlintNumericTextBox";
import FlintFieldset from "../../../../components/layout/FlintFieldset";
import {WindowActionsBar} from "@progress/kendo-react-dialogs";
import FlintButton from "../../../../components/controls/FlintButton";
import {useFlintDialogContext} from "../../../../components/page_components/common/dialogs/FlintDialogContextProvider";

export default function ResultsDeliveredUpdateComponent(props: ResultsDeliveredUpdateComponentProps) {
    const {state, handlers, utils} = useResultsDeliveredUpdateComponent(props);
    const {t} = useTranslation();
    const timeReporting = state.vivoPanel?.get?.TimeReporting;
    const r = state.responseModel;
    const badge = (dbQuantity?: number, currentQuantity?: number | null) => {
        const v = ((dbQuantity ?? 0) + (currentQuantity ?? 0)).toString();
        return <div className={"badge text-bg-info"}>{v}</div>
    }
    return (
        <div>
            <FlintLoadingWrapper showLoading={state.isLoading.get}>
                <FlintFieldset legend={t("lblResultsDelivered")} marginBottom={"auto"} showLegendBorder={true}>
                    <div className={"row"}>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("lblJobsCount")} format={"n0"} min={0}
                                                 value={r.get.DeltaJobsQuantity}
                                                 onChange={x => r.set("DeltaJobsQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedJobsQuantity, r.get.DeltaJobsQuantity)}
                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("lblDatabaseRecipes")} format={"n0"} min={0}
                                                 value={r.get.DeltaDatabaseRecipesQuantity}
                                                 onChange={x => r.set("DeltaDatabaseRecipesQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedDatabaseRecipesQuantity, r.get.DeltaDatabaseRecipesQuantity)}
                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("lblColorStandardsDeliveredNumber")} format={"n0"} min={0}
                                                 value={r.get.DeltaColorStandardsDeliveredQuantity}
                                                 onChange={x => r.set("DeltaColorStandardsDeliveredQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedColorStandardsDeliveredQuantity, r.get.DeltaColorStandardsDeliveredQuantity)}
                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("lblDsPdfFileNumber")} format={"n0"} min={0}
                                                 value={r.get.DeltaDsPdfFileQuantity}
                                                 onChange={x => r.set("DeltaDsPdfFileQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedDsPdfFileQuantity, r.get.DeltaDsPdfFileQuantity)}
                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("COMMON_WetSample")} format={"n0"} min={0}
                                                 value={r.get.DeltaWetSamplesQuantity}
                                                 onChange={x => r.set("DeltaWetSamplesQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedWetSamplesQuantity, r.get.DeltaWetSamplesQuantity)}
                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox label={t("lblDsPrintedNo")} format={"n0"} min={0}
                                                 value={r.get.DeltaDsPrintedQuantity}
                                                 onChange={x => r.set("DeltaDsPrintedQuantity", x.value)}/>
                            {badge(timeReporting?.ReportedDsPrintedQuantity, r.get.DeltaDsPrintedQuantity)}
                        </div>
                    </div>
                </FlintFieldset>
                <FlintFieldset legend={t("activitiesTimes")} showLegendBorder={true} marginBottom={"auto"}>
                    <div className={"row align-items-end"}>
                        <div className={"col-4 form-group"}>
                            <FlintNumericTextBox label={t("ORDER_COLOUR_MATCHING")} format={"n0"} min={0}
                                                 value={r.get.DeltaTimeColourMatching}
                                                 onChange={x => r.set("DeltaTimeColourMatching", x.value)}/>
                        </div>
                        <div className={"col-4 form-group"}>
                            <FlintNumericTextBox label={t("ORDER_COLOUR_STANDARD")} format={"n0"} min={0}
                                                 value={r.get.DeltaTimeColourStandard}
                                                 onChange={x => r.set("DeltaTimeColourStandard", x.value)}/>
                        </div>
                        <div className={"col-4 form-group"}>
                            <FlintNumericTextBox label={t("ORDER_DIGI_SWATCH")} format={"n0"} min={0}
                                                 value={r.get.DeltaTimeDigiSwatch}
                                                 onChange={x => r.set("DeltaTimeDigiSwatch", x.value)}/>
                        </div>
                        <div className={"col-4 form-group"}>
                            <FlintNumericTextBox label={t("ORDER_DIGI_SWATCH_PRINT")} format={"n0"} min={0}
                                                 value={r.get.DeltaTimeDigiSwatchPrint}
                                                 onChange={x => r.set("DeltaTimeDigiSwatchPrint", x.value)}/>
                        </div>
                        <div className={"col-4 form-group"}>
                            <FlintNumericTextBox label={t("COMMON_WetSample")} format={"n0"} min={0}
                                                 value={r.get.DeltaTimeWetSamples}
                                                 onChange={x => r.set("DeltaTimeWetSamples", x.value)}/>

                        </div>
                        <div className={"col-4 form-group d-flex gap-2 align-items-start"}>
                            <FlintNumericTextBox disabled={true} label={t("lblTimeInMinutes")}
                                                 value={utils.currentTimeReported}
                                                 format={"n0"} min={0}/>
                            {badge(timeReporting?.ReportedTimeSpentInMinutes, utils.currentTimeReported)}
                        </div>
                    </div>
                </FlintFieldset>
                {/*{false && <FlintFieldset legend={t("ORDER_PREVIEW_AdditionalActivity")} showLegendBorder={true} marginBottom={0}>*/}
                {/*    <div className={"row"}>*/}
                {/*        <div className={"col-4 form-group"}>*/}
                {/*            <FlintDropDownList<NameWithId> dataSource={timeReporting?.AvailableAdditionalActivities}*/}
                {/*                                           disabled={timeReporting?.AdditionalActivity != null}*/}
                {/*                                           usePrimitives={true}*/}
                {/*                                           label={t("ORDER_PREVIEW_AdditionalActivity")}*/}
                {/*                                           selectedValue={r.get.AdditionalActivityTypeId}*/}
                {/*                                           defaultItem={{*/}
                {/*                                               Id: 0,*/}
                {/*                                               Name: '',*/}
                {/*                                               Guid: '',*/}
                {/*                                               Deleted: false,*/}
                {/*                                               IdString: ''*/}
                {/*                                           }}*/}
                {/*                                           onItemSelected={x => r.set("AdditionalActivityTypeId", x.Id)}/>*/}
                {/*        </div>*/}
                {/*        {(r.get.AdditionalActivityTypeId ?? 0) > 0 && <>*/}
                {/*            <div className={"col-4 form-group d-flex gap-2 align-items-start"}>*/}
                {/*                <FlintNumericTextBox label={t("QUANTITY")}*/}
                {/*                                     format={"n0"} min={0}*/}
                {/*                                     value={r.get.DeltaAdditionalActivityQuantity}*/}
                {/*                                     onChange={x => r.set("DeltaAdditionalActivityQuantity", x.value)}/>*/}
                {/*                {timeReporting?.AdditionalActivity != null && badge(timeReporting?.AdditionalActivityQuantity, r.get.DeltaAdditionalActivityQuantity)}*/}
                {/*            </div>*/}
                {/*            <div className={"col-4 form-group"}>*/}
                {/*                <FlintNumericTextBox label={t("TIME")} format={"n0"} min={0}*/}
                {/*                                     value={r.get.DeltaAdditionalActivityTime}*/}
                {/*                                     onChange={x => r.set("DeltaAdditionalActivityTime", x.value)}/>*/}
                {/*            </div>*/}
                {/*        </>}*/}
                {/*    </div>*/}
                {/*</FlintFieldset>}*/}
            </FlintLoadingWrapper>
            <WindowActionsBar layout={"center"}>
                <FlintButton disabled={state.isLoading.get} themeColor={"secondary"}
                             onClick={handlers.handleCancelled}>{t("Cancel")}</FlintButton>
                <FlintButton disabled={state.isLoading.get} themeColor={"primary"}
                             onClick={handlers.handleConfirmed}>{t("Confirm")}</FlintButton>
            </WindowActionsBar>
        </div>
    )
}

export interface ResultsDeliveredUpdateComponentProps extends BasePopupProps {
    orderPreviewModelState: OrderPreviewModelStateType,
    WarnIfNotFilled: boolean;
}

function useResultsDeliveredUpdateComponent(props: ResultsDeliveredUpdateComponentProps) {
    const [isLoading, setIsLoading] = useState(false);
    const {showNotification} = useFlintNotificationContext();
    const {t} = useTranslation();
    const {showAreYouSureDialog} = useFlintDialogContext();
    const basicDataState = props.orderPreviewModelState.get.OrderBasicData;
    const [responseModel, setResponseModel] = useState<TimeReportingRequest>({
        OrderGuid: basicDataState.Guid,
        IsComplaint: false,
        DeltaJobsQuantity: null,
        DeltaDatabaseRecipesQuantity: null,
        DeltaColorStandardsDeliveredQuantity: null,
        DeltaDsPdfFileQuantity: null,
        DeltaDsPrintedQuantity: null,
        DeltaWetSamplesQuantity: null,
        DeltaTimeColourMatching: null,
        DeltaTimeColourStandard: null,
        DeltaTimeDigiSwatch: null,
        DeltaTimeDigiSwatchPrint: null,
        DeltaTimeWetSamples: null,
        AdditionalActivityTypeId: props.orderPreviewModelState.get.VivoPanelModel?.TimeReporting?.AdditionalActivity?.Id, // Optional
        DeltaAdditionalActivityQuantity: null, // Optional
        DeltaAdditionalActivityTime: null, // Optional
    });

    function setResponse<T extends keyof TimeReportingRequest>(key: T, value: TimeReportingRequest[T]) {
        setResponseModel(prev => ({
            ...prev,
            [key]: value
        }));
    }

    function getCurrentTimeReported() {
        return (responseModel?.DeltaTimeWetSamples ?? 0)
            + (responseModel?.DeltaTimeColourMatching ?? 0)
            + (responseModel?.DeltaTimeColourStandard ?? 0)
            + (responseModel?.DeltaTimeDigiSwatch ?? 0)
            + (responseModel?.DeltaTimeDigiSwatchPrint ?? 0)
            + (responseModel?.DeltaAdditionalActivityTime ?? 0);
    }

    function handleCancelled() {
        props.OnCancelled();
    }

    function responseModelContainsEmptyValues() {
        if (responseModel.DeltaJobsQuantity == null)
            return true;
        if (responseModel.DeltaDatabaseRecipesQuantity == null)
            return true;
        if (responseModel.DeltaColorStandardsDeliveredQuantity == null)
            return true;
        if (responseModel.DeltaDsPdfFileQuantity == null)
            return true;
        if (responseModel.DeltaDsPrintedQuantity == null)
            return true;
        if (responseModel.DeltaWetSamplesQuantity == null)
            return true;
        if (responseModel.DeltaTimeColourMatching == null)
            return true;
        if (responseModel.DeltaTimeColourStandard == null)
            return true;
        if (responseModel.DeltaTimeDigiSwatch == null)
            return true;
        if (responseModel.DeltaTimeDigiSwatchPrint == null)
            return true;
        if (responseModel.DeltaTimeWetSamples == null)
            return true;
        if (responseModel.AdditionalActivityTypeId) {
            if (responseModel.DeltaAdditionalActivityQuantity == null)
                return true;
            if (responseModel.DeltaAdditionalActivityTime == null)
                return true;
        }
        return false;
    }

    function handleConfirmed() {
        if (props.WarnIfNotFilled && responseModelContainsEmptyValues()) {
            return showAreYouSureDialog({
                onAccept: () => saveResults(),
                title: t("COMMON_Confirmation"),
                content: t("ORDER_PREVIEW_ResultsNotCompletedWarning"),
                cancelButtonText: t("ORDER_PREVIEW_ResultsNotCompletedRejectButtonText")
            })
        }
        return saveResults();
    }

    function saveResults() {
        if (isLoading)
            return;
        setIsLoading(true);
        return axios.post<ApiResponseDto<OrderPreviewVivoPanelModel>>(ApiUrl_Orders_ReportOrderActivities, responseModel)
            .then(res => {
                props.orderPreviewModelState.set("VivoPanelModel", res.data.Result);
                props.OnConfirmedAndSaved();
            })
            .catch(err => showNotification(err))
            .finally(() => setIsLoading(false));
    }

    return {
        state: {
            vivoPanel: {get: props.orderPreviewModelState.get.VivoPanelModel},
            isLoading: {get: isLoading},
            responseModel: {get: responseModel, set: setResponse}
        },
        handlers: {
            handleCancelled,
            handleConfirmed
        },
        utils: {
            currentTimeReported: getCurrentTimeReported(),
        }
    }
}